var styleDataHash = "58d4353b";
const injectCss = () => {
  var css = `.hE8rM{--wds-side-panel-content-padding-vertical:0px}[dir] .t7nG7{padding-bottom:calc(var(--wds-side-panel-footer-padding-vertical, 18px)*2 + var(--wds-button-size-small, 30px))!important}.QT80e{--wds-side-panel-footer-padding-vertical:18px;bottom:0;position:absolute}[dir] .QT80e{background:var(--wds-color-fill-surface-overlay,var(--wsr-color-D80,#fff))}[dir=ltr] .QT80e,[dir=rtl] .QT80e{left:0;right:0}.vVsdl{height:100%}`;
  var isTest = typeof process !== "undefined" && process.env && false;
  if (isTest || !css || typeof document === "undefined") {
    return;
  }
  if (document.querySelector('style[data-ricos-style-hash="' + styleDataHash + '"]')) {
    return;
  }
  var head = document.head || document.getElementsByTagName("head")[0];
  var style = document.createElement("style");
  style.setAttribute("data-ricos-style-hash", styleDataHash);
  style.type = "text/css";
  head.appendChild(style);
  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
};
injectCss();
var fullscreen_mobile_layout_default = {
  "content": "hE8rM",
  "contentWithFooter": "t7nG7",
  "footer": "QT80e",
  "fullscreen": "vVsdl"
};
export {
  fullscreen_mobile_layout_default as default,
  injectCss
};
//# sourceMappingURL=fullscreen-mobile-layout-scss.js.map
